import { Card, CardContent, CardHeader } from '@mui/material'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableContainer from '@mui/material/TableContainer'
import TableFooter from '@mui/material/TableFooter'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import { ActionButton, ChargeSelect, Wrapper } from './styles'
import Delete from '@mui/icons-material/Delete'
import { useCallback, useEffect, useState } from 'react'
import Paper from '@mui/material/Paper'
import TablePaginationActions from '../../components/TablePaginationActions'
import API from '../../services/api'
import { useNotify } from 'react-admin'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import moment from 'moment'

interface Status {
  0: string
  1: string
  2: string
}

export const ChargeStatus: Status = {
  0: 'PENDENTE',
  1: 'PAGA',
  2: 'DELETADA',
}

const Charges = () => {
  const notify = useNotify()

  const [status, setStatus] = useState(0)

  const [chargeRows, setChargeRows] = useState<any>([])
  const [chargePage, setChargePage] = useState(0)
  const [chargeRowsPerPage, setChargeRowsPerPage] = useState(5)
  const [chargeRowsTotal, setChargeRowsTotal] = useState(0)

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setChargePage(newPage)
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setChargeRowsPerPage(parseInt(event.target.value, 10))
    setChargePage(0)
  }

  const loadCharges = useCallback(async () => {
    try {
      const response = await API.get(
        `/charges?page=${chargePage + 1}&limit=${chargeRowsPerPage}&status=${status}`
      )

      setChargeRows(response.data.charges.data)
      setChargeRowsTotal(response.data.charges.meta.total)
    } catch (error) {
      console.log(error)
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }, [notify, chargePage, chargeRowsPerPage, status])

  const deleteCharge = async (chargeId: number) => {
    try {
      await API.delete(`/charges/${chargeId}`)

      notify('Cobrança deletada com sucesso.', { type: 'success' })
      loadCharges()
    } catch (error) {
      console.log(error)
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  useEffect(() => {
    loadCharges()
  }, [loadCharges])

  return (
    <Card>
      <CardHeader title="Cobranças" />
      <CardContent>
        <Wrapper>
          <ChargeSelect value={status} onChange={(ev) => setStatus(+ev.target.value)}>
            <option value={0}>PENDENTE</option>
            <option value={1}>PAGA</option>
          </ChargeSelect>

          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell align="left">Descrição</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Valor</TableCell>
                  <TableCell>Data</TableCell>
                  <TableCell>Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {chargeRows.map((row: any) => (
                  <TableRow key={row.id}>
                    <TableCell style={{ width: 20 }} component="th" scope="row">
                      {row.id}
                    </TableCell>
                    <TableCell style={{ flex: 1 }}>{row.description}</TableCell>
                    <TableCell
                      style={{ width: 200, color: row.status === 0 ? '#C28220' : '#2F9D6C' }}
                    >
                      {ChargeStatus[row.status as keyof Status]}
                    </TableCell>
                    <TableCell style={{ width: 200 }}>R$ {row.amount / 100}</TableCell>
                    <TableCell style={{ width: 200 }}>
                      {moment(row.created_at).format('DD/MM/YYYY HH:mm')}
                    </TableCell>
                    <TableCell style={{ width: 200 }}>
                      {row.status === 0 && (
                        <ActionButton
                          style={{ color: '#00A76F' }}
                          title="Pagar"
                          onClick={() => {
                            window.open(row.init_point, '_blank')
                          }}
                        >
                          <AttachMoneyIcon />
                        </ActionButton>
                      )}
                      {row.status === 0 && (
                        <ActionButton
                          style={{ marginLeft: '5px', color: '#B71D18' }}
                          title="Deletar"
                          onClick={() => {
                            deleteCharge(row.id)
                          }}
                        >
                          <Delete />
                        </ActionButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                    colSpan={3}
                    count={chargeRowsTotal}
                    rowsPerPage={chargeRowsPerPage}
                    page={chargePage}
                    SelectProps={{
                      inputProps: {
                        'aria-label': 'rows per page',
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </Wrapper>
      </CardContent>
    </Card>
  )
}

export default Charges
